// removed by extract-text-webpack-plugin
module.exports = {"indent":"_3Z5Q9NzL0BpSvV0AVv6iez"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/DevicesStatistics/DevicesStatistics.scss
// module id = 1379
// module chunks = 1